<template>
  <div class="riderSet">
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20 mar_l20">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('rider.settings.title') }}</span>
          </div>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('rider.settings.orderCondition')" :required="true" prop="condition">
          <el-checkbox-group v-model="form.condition">
            <el-checkbox label="4" disabled>{{ $t('rider.settings.realNameAuth') }}</el-checkbox>
            <el-checkbox label="3">{{ $t('rider.settings.deposit') }}</el-checkbox>
<!--            <el-checkbox label="1">线下培训</el-checkbox>-->
<!--            <el-checkbox label="2">线上考试</el-checkbox>-->
          </el-checkbox-group>
          <div class="yb_margin lh16">{{ $t('rider.settings.orderConditionTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.pickUpCondition')">
          <el-radio-group v-model="form.pickUpType" :required="true" prop="isReceivePhoto">
            <el-radio label="0">{{ $t('rider.settings.none') }}</el-radio>
            <el-radio label="1">{{ $t('rider.settings.pickUpCode') }}</el-radio>
            <el-radio label="2">{{ $t('rider.settings.pickUpPhoto') }}</el-radio>
          </el-radio-group>
          <div class="yb_margin lh16">{{ $t('rider.settings.pickUpTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.deliveryCondition')">
          <el-radio-group v-model="form.serviceType" :required="true" prop="isReceivePhoto">
            <el-radio label="0">{{ $t('rider.settings.none') }}</el-radio>
            <el-radio label="1">{{ $t('rider.settings.deliveryCode') }}</el-radio>
            <el-radio label="2">{{ $t('rider.settings.deliveryPhoto') }}</el-radio>
          </el-radio-group>
          <div class="yb_margin lh16">{{ $t('rider.settings.deliveryTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.orderRangeLimit')" :required="true" prop="orderRange">
          <el-input v-model.number="form.orderRange" autocomplete="off" :placeholder="$t('rider.settings.orderRangePh')">
            <template slot="append">{{ $t('rider.settings.withinKm') }}</template>
          </el-input>
          <div class="yb_margin lh16">{{ $t('rider.settings.orderRangeTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.arrivalDistanceLimit')" :required="true" prop="arrivalDistanceLimit">
          <el-input v-model.number="form.arrivalDistanceLimit" autocomplete="off" :placeholder="$t('rider.settings.arrivalDistancePh')">
            <template slot="append">{{ $t('rider.settings.withinMeter') }}</template>
          </el-input>
          <div class="yb_margin lh16">{{ $t('rider.settings.arrivalDistanceTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.serviceDistanceLimit')" :required="true" prop="serviceDistanceLimit">
          <el-input v-model.number="form.serviceDistanceLimit" autocomplete="off" :placeholder="$t('rider.settings.serviceDistancePh')">
            <template slot="append">{{ $t('rider.settings.withinMeter') }}</template>
          </el-input>
          <div class="yb_margin lh16">{{ $t('rider.settings.serviceDistanceTip') }}</div>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.arrivalTimeLimit')" :required="true" prop="arrivalTimeStartDistance">
          <div>
            <el-input v-model.number="form.arrivalTimeStartDistance" autocomplete="off" :placeholder="$t('rider.settings.enterKm')">
              <template slot="append">{{ $t('rider.settings.withinKmShort') }}</template>
            </el-input>
            <el-input v-model.number="form.arrivalTimes" autocomplete="off" class="mar_l20" :placeholder="$t('rider.settings.enterMinute')">
              <template slot="append">{{ $t('rider.settings.minuteComplete') }}</template>
            </el-input>
          </div>
          <div class="mar_t10" v-for="(item, index) in form.arrivalTimeArr" :key="index">
            <el-input v-model.number="item.overKilometre" autocomplete="off" :placeholder="$t('rider.settings.enterKm')">
              <template slot="append">{{ $t('rider.settings.afterKm') }}</template>
            </el-input>
            <el-input v-model.number="item.minute" autocomplete="off" class="mar_l20" :placeholder="$t('rider.settings.enterMinute')">
              <template slot="prepend">{{ $t('rider.settings.perKmAdd') }}</template>
              <template slot="append">{{ $t('rider.settings.minute') }}</template>
            </el-input>
            <el-button size="mini" type="text" @click="delSpecMethod(index)" class="mar_l20">{{ $t('common.delete') }}</el-button>
          </div>
          <el-button type="text" class @click="addSpecMethod" v-show="form.arrivalTimeArr.length < 3">{{ $t('common.add') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('rider.settings.serviceTimeLimit')" :required="true">
          <div>
            <el-input v-model.number="form.serviceTimeStartDistance" autocomplete="off" :placeholder="$t('rider.settings.enterKm')">
              <template slot="append">{{ $t('rider.settings.withinKmShort') }}</template>
            </el-input>
            <el-input v-model.number="form.serviceTimes" autocomplete="off" class="mar_l20" :placeholder="$t('rider.settings.enterMinute')">
              <template slot="append">{{ $t('rider.settings.minuteComplete') }}</template>
            </el-input>
          </div>
          <div class="mar_t10" v-for="(item, index) in form.serviceTimeArr" :key="index">
            <el-input v-model.number="item.overKilometre" autocomplete="off" :placeholder="$t('rider.settings.enterKm')">
              <template slot="append">{{ $t('rider.settings.afterKm') }}</template>
            </el-input>
            <el-input v-model.number="item.minute" autocomplete="off" class="mar_l20" :placeholder="$t('rider.settings.enterMinute')">
              <template slot="prepend">{{ $t('rider.settings.perKmAdd') }}</template>
              <template slot="append">{{ $t('rider.settings.minute') }}</template>
            </el-input>
            <el-button size="mini" type="text" @click="delSpecMethod2(index)" class="mar_l20">{{ $t('common.delete') }}</el-button>
          </div>
          <el-button type="text" class @click="addSpecMethod2" v-show="form.serviceTimeArr.length < 3">{{ $t('common.add') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from '@/api/set';
export default {
  data() {
    return {
      form: {
        condition: ['4'],
        isFace: '',
        pickUpType: '0',
        serviceType: '0',
        isReceivePhoto: '',
        orderRange: '',
        arrivalDistanceLimit: '',
        serviceDistanceLimit: '',
        arrivalTimeStartDistance: '',
        arrivalTimes: '',
        arrivalTimeArr: [
          {
            overKilometre: '',
            minute: ''
          }
        ],
        serviceTimeStartDistance: '',
        serviceTimes: '',
        serviceTimeArr: [
          {
            overKilometre: '',
            minute: ''
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    addtimeInterval1() {
      let specObj = { startTime: '00:00', endTime: '00:00', money: '' };
      this.$set(this.form.timeArr, this.form.timeArr.length, specObj);
    },
    deltimeInterval1(index) {
      this.$delete(this.form.timeArr, index);
    },
    addSpecMethod() {
      let specObj = {
        overKilometre: '',
        minute: ''
      };
      this.$set(this.form.arrivalTimeArr, this.form.arrivalTimeArr.length, specObj);
    },
    addSpecMethod2() {
      let specObj = {
        overKilometre: '',
        minute: ''
      };
      this.$set(this.form.serviceTimeArr, this.form.serviceTimeArr.length, specObj);
    },
    delSpecMethod(index) {
      this.$delete(this.form.arrivalTimeArr, index);
    },
    delSpecMethod2(index) {
      this.$delete(this.form.serviceTimeArr, index);
    },

    async init() {
      const { data } = await getConfig({ ident: 'rider' });
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
      if (this.form.condition.indexOf('4') < 0) {
        this.form.condition.push('4');
      }
    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.ident = 'rider';
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, 'success');
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.riderSet {
  min-width: 1100px !important;

  .el-form-item__content {
    text-align: left;
  }

  .tsinput .el-input {
    width: 300px !important;
  }
}
</style>
